/**
* Floating CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Floating CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'floating-cta',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
        if ( window.hasMotion ) {
          llParallax();

          $( window ).on( 'resize', function() {
            llParallax();
          } );
        }
      }
      function llParallax() {
        $( '.floating-cta .ll-parallax-up' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=25% bottom',
              end: 'bottom top',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 50}, {yPercent: 0} );
        } );

        $( '.floating-cta .ll-parallax-middle' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=76px bottom+=100%',
              end: 'bottom top',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 50}, {yPercent: 0} );
        } );

        $( '.floating-cta .ll-parallax-down' ).each( function() {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: 'top+=76px bottom',
              end: 'bottom top+=0px',
              pin: false,
              // markers: true,
              scrub: 1,
              delay: 0.25,
            },
          } );
          tl.fromTo( $( this ), {yPercent: 0}, {yPercent: 16} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'floating-cta', COMPONENT );
} )( app );
